// extracted by mini-css-extract-plugin
export default {"error":"Error_error__Y5c13","content":"Error_content__BUxN+","image":"Error_image__BZV0L"};